import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: Users,
    text: '+1.000 mamás confían'
  }, {
    icon: BookOpen,
    text: '6 Tomos completos'
  }, {
    icon: Gift,
    text: '6 Bonos incluidos'
  }, {
    icon: Star,
    text: '4.9/5 calificación',
    isStar: true
  }];
  return <section className="py-5 border-y border-pink-200 bg-pink-50/50" data-id="element-294">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-296">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col items-center text-center gap-3" data-id="element-297">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center" data-id="element-298">
                <stat.icon size={24} className="text-brand-accent" data-id="element-299" />
              </div>
              <p className="font-medium text-gray-600 text-sm md:text-base" data-id="element-300">
                {stat.text}
                {stat.isStar && <span className="text-brand-accent ml-1" data-id="element-301">⭐</span>}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}